import React from "react";
import PropTypes from "prop-types";
import styles from "../styles/TopBarStyles";

const TopBar = ({ leftContainer, centerContainer, rightContainer }) => {
  return (
    <div style={styles.topBar}>
      <div style={styles.leftContainer}>{leftContainer}</div>
      <div style={styles.centerContainer}>{centerContainer}</div>
      <div style={styles.rightContainer}>{rightContainer}</div>
    </div>
  );
};

TopBar.propTypes = {
  leftContainer: PropTypes.node,
  centerContainer: PropTypes.node,
  rightContainer: PropTypes.node,
};

export default TopBar;
